import { JSX, useEffect, useRef, useState } from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";
import { IModalidades, INumeroExtracto } from "../interfaces/interfaces";
import ColumnExtracto from "./columnExtracto";

interface Props {
  lastHeadExtractos: IModalidades[];
  numerosExtractos: INumeroExtracto[];
  getHeadModalidad: (modalidad: IModalidades) => void;
  actionsButton: (action: any) => void;
}

const AutoplaySwiper = (props: Props) => {
  const {
    lastHeadExtractos,
    numerosExtractos,
    getHeadModalidad,
    actionsButton,
  } = props;
  const [stateModalidad, setStateModalidad] = useState<IModalidades[]>([]);
  const swiperRef = useRef<any>(null);

  useEffect(() => {
    actionsButton(swiperRef.current);

    let r = [
      ...lastHeadExtractos.filter((numero) => numero.idModalidad !== 30),
    ];
    setStateModalidad(r);

    stateModalidad && getHeadModalidad(r[0]);
  }, []);

  return (
    <Swiper
      spaceBetween={20}
      centeredSlides={true}
      autoplay={{
        delay: 20700,
        disableOnInteraction: false,
      }}
      grabCursor={true}
      pagination={{
        clickable: true,
      }}
      navigation={false}
      modules={[Autoplay, Navigation]}
      className="mySwiper"
      onBeforeInit={(swiper: any) => {
        swiperRef.current = swiper;
      }}
      onActiveIndexChange={(swiperCore: any) => {
        getHeadModalidad(stateModalidad[swiperCore.activeIndex]);
      }}
    >
      {stateModalidad &&
        stateModalidad.length > 0 &&
        getSwiperSlider(stateModalidad)}
    </Swiper>
  );

  function getSwiperSlider(headExtractoModalidad: IModalidades[]) {
    let array: JSX.Element[] = [];

    for (const i of headExtractoModalidad) {
      //let keyC = `colkey${i.idModalidad}${randomBytes(3)}`;
      let keyC = `colkey${i.idModalidad}`;
      let numerosModalidad = numerosExtractos.filter(
        (numero) => numero.idModalidad === i.idModalidad
      );

      array.push(
        <SwiperSlide key={"swiperid" + i.idModalidad}>
          <ColumnExtracto
            key={keyC}
            loteriasHead={i.items}
            numerosModalidad={numerosModalidad}
          />
        </SwiperSlide>
      );
    }

    return array;
  }
};

export default AutoplaySwiper;
